import { defineStore } from 'pinia'
import axios from 'axios'
import { getResponse, getError, getMeta } from '@/composables/api'
import { useToastsStore } from '@/stores/notifications/toasts'
import { useGinnelsStore } from '@/stores/ginnels/ginnels'
import router from '@/router'

export const useCollectionsStore = defineStore({
   id: 'collections',
   state: () => ({
      collections: [],
      gotCollections: false,

      currentPage: 1,
      hasMoreData: true,

      storeToasts: useToastsStore(),
      storeGinnels: useGinnelsStore(),
   }),
   actions: {
      /**
         * Function: get
         * @description Sends a get requiest to the API
         * to get all collections.
      */
      get(payload = null) {
         this.gotCollections = false

         if(! payload) payload = { page: 1 }
         if(payload == 'all') payload = { limit: 0 }

			axios.get('collections', { params: payload }).then(response => {
            this.gotCollections = true
            // If the page is greater than 1, append the data, otherwise replace the data.
            if(payload?.page > 1)
               this.collections = this.collections.concat(getResponse(response))
            else
               this.collections = getResponse(response)

				this.currentPage = getMeta(response)?.current_page
				this.hasMoreData = getMeta(response)?.has_more_data
			})
      },
      /**
         * Function: add
         * @description Sends a post requiest to the API
         * to add a collection.
         *
         * @param {String} name
      */
      add(name) {
			axios.post('collection', { name: name }).then(response => {
            let collection = getResponse(response)
            this.collections.unshift(collection)

            router.push({ name: 'collection', params: { collection_id: collection.id } })
            this.storeGinnels.get(collection.id)
			}).catch(response => {
            console.log(getError(response))
         })
      },
      /**
         * Function: edit
         * @description Sends a put requiest to the API
         * to update a collection.
         *
         * @param {Object} formData
      */
      edit(formData) {
			axios.put('collection', formData).then(response => {
            // Edit collection in local collections array
            let collection = this.collections.find(collection => collection.id == formData?.collection_id)
            collection.name = formData.name

            this.storeToasts.sendToast(getResponse(response))
			}).catch(response => {
            console.log(getError(response))
         })
      },
      /**
         * Function: delete
         * @description Sends a delete requiest to the API
         * to delete a collection.
         *
         * @param {Number} id Collection ID
      */
      delete(id) {
			axios.delete('collection', { params: { collection_id: id } }).then(response => {
            // Delete collection from local collections array
            let index = this.collections.findIndex(collection => collection.id == id)
            this.collections.splice(index, 1)

            if(! this.collections.length) router.push({ name: 'home' })
            else {
               let gotoID = this.collections[0].id
               router.push({ name: 'collection', params: { collection_id: gotoID } })
               this.storeGinnels.get(gotoID)
            }

            this.storeToasts.sendToast(getResponse(response))
			}).catch(response => {
            if(getError(response))
               this.storeToasts.sendToast(getError(response), 'danger')
            else
               this.storeToasts.sendToast(response, 'danger')
         })
      },
   }
})